import type { Company } from "./Company"
import type { Id } from "./GenericEntity"
import { getRolePriority, SystemRole } from "./SystemRole"
import type { User } from "./User"

/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging */
export interface LoggedInUser extends User {}
export class LoggedInUser implements User {
	constructor(user: User) {
		Object.assign(this, user)
	}

	atLeastHasRole(role: SystemRole): boolean {
		const ownPriority = getRolePriority(this.role)
		const rolePriority = getRolePriority(role)

		return ownPriority >= rolePriority
	}

	isAssignedToCompany(company: Id | Company): boolean {
		const companyId = typeof company === "number" ? company : company.id
		return companyId === this.companyId
	}

	canViewCompany(company: Id | Company): boolean {
		return this.atLeastHasRole(SystemRole.Administrator) || this.isAssignedToCompany(company)
	}
}
